<script>
import { mapState, mapActions } from "vuex";
import MainTitleBack from "@/components/helpers/MainTitleBack.vue";
import MainSelect from "@/components/helpers/MainSelect.vue";
import MainDocument from "@/components/helpers/MainDocument.vue";
import MainLoader from "@/components/helpers/MainLoader.vue";
import { DOCUMENT_SECTIONS, VIP_SECTIONS } from "@/modules/documents/constants";

export default {
  components: {
    MainTitleBack,
    MainSelect,
    MainDocument,
    MainLoader,
  },

  data() {
    return {
      isLoading: false,
      documents: null,
      rdo_documents: null,
      loadingDocuments: false,

      selectedOption: {},
      selectedSection: [],
      documentSections: [],
      select_rdo_section: "",
      viewDocuments: null,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),

    filteredDocuments() {
      if (!this.isUserNoVip) {
        return this.documentSections;
      }

      return this.documentSections.filter((document) => {
        return (
          document.id !== "tsp_materials" && document.id !== "tsp_documents"
        );
      });
    },

    formattedListOfSections() {
      return this.filteredDocuments.map((item) => {
        return {
          name: item.title,
          ...item,
        };
      });
    },

    indexOfSelectedSection() {
      return this.formattedListOfSections.findIndex((section) => {
        return section.id === this.selectedSection;
      });
    },

    disabledArrowLeft() {
      return this.indexOfSelectedSection === 0;
    },

    disabledArrowRight() {
      return this.indexOfSelectedSection + 1 === this.filteredDocuments.length;
    },

    isUserNoVip() {
      return (
        (this.user.tariff?.code !== "vip_d" &&
          this.user.tariff?.code !== "vip_gold_d") ||
        this.user.tariff === null
      );
    },

    isEmptyDocs() {
      return Object.keys(this.selectedOption).length === 0;
    },
  },

  watch: {
    selectedSection: {
      deep: true,
      handler() {
        this.selectedOption = this.formattedListOfSections[
          this.indexOfSelectedSection
        ];
      },
    },

    async "$route.params.id"(newValue) {
      this.selectedSection = newValue;

      try {
        this.isLoading = true;
        await this.getCurrentSectionDocumentGroup(this.selectedSection);
      } finally {
        this.isLoading = false;
      }
    },
  },

  methods: {
    ...mapActions({
      loadDocuments: "loadDocuments",
      loadRdoDocuments: "loadRdoDocuments",
      loadESDDocuments: "loadESDDocuments",
    }),

    changeHandler() {
      this.getData();

      this.$router.replace({
        params: {
          id: this.selectedSection,
        },
      });
    },

    getData() {
      this.select_rdo_section = "";
      this.selectedSection = this.filteredDocuments.find((section) => {
        return section.id === this.selectedOption.id;
      }).id;

      // this.getCurrentSectionDocumentGroup(this.selectedSection);
    },

    async changeSection(indexOfSection) {
      if (this.isLoading) {
        return;
      }

      if (
        indexOfSection >= 0 &&
        indexOfSection < this.filteredDocuments.length
      ) {
        this.selectedSection = this.filteredDocuments[indexOfSection].id;
        await this.$router.replace({ params: { id: this.selectedSection } });
      }
    },

    async getCurrentSectionDocumentGroup(documentId) {
      this.viewDocuments = [];

      const document = DOCUMENT_SECTIONS.find((item) => item.id === documentId);
      if (!!document) {
        try {
          this.loadingDocuments = true;
          const doc = await this.loadESDDocuments(document.link);
          this.viewDocuments = doc.data;
        } finally {
          this.loadingDocuments = false;
        }
      }
    },
  },

  async mounted() {
    if (this.isUserNoVip) {
      this.documentSections = DOCUMENT_SECTIONS.filter((section) => {
        return section.id !== "tsp_materials" || section.id !== "tsp_documents";
      });

      if (VIP_SECTIONS.includes(this.$route.params.id)) {
        await this.$router.replace({
          params: { id: this.documentSections[0].id },
        });
      }
    } else {
      this.documentSections = DOCUMENT_SECTIONS;
    }
    const indexOfSection = this.formattedListOfSections.findIndex((section) => {
      return section.id === this.$route.params.id;
    });
    this.selectedOption = this.formattedListOfSections[indexOfSection];
    this.getData();
    await this.getCurrentSectionDocumentGroup(this.selectedSection);
  },
};
</script>

<template>
  <div class="documents-section default-content-padding">
    <template v-if="!isEmptyDocs">
      <main-title-back
        class="documents-section__title"
        :title="selectedOption.name"
        href="Documents"
      />

      <div class="documents-section__section-selector">
        <span
          class="documents-section__arrow"
          :class="{
            'documents-section__arrow_disabled': disabledArrowLeft || isLoading,
          }"
          @click="changeSection(indexOfSelectedSection - 1)"
        ></span>

        <main-select
          :selected-option.sync="selectedOption"
          :options="formattedListOfSections"
          style-type="background-white"
          @update:selectedOption="changeHandler"
        />

        <span
          class="documents-section__arrow"
          :class="{
            'documents-section__arrow_disabled':
              disabledArrowRight || isLoading,
          }"
          @click="changeSection(indexOfSelectedSection + 1)"
        ></span>
      </div>

      <main-loader v-if="loadingDocuments" />

      <div
        v-if="!loadingDocuments && viewDocuments"
        class="documents-section__documents"
      >
        <main-document
          v-for="document in viewDocuments"
          :key="document.id"
          :title="document.name"
          :description="document.description"
          :url="document.body_link"
        />
      </div>
    </template>

    <!--    <div-->
    <!--      v-if="!loadingDocuments && rdo_documents && selectedSection.id === 'rdo'"-->
    <!--      class="documents-section__collapse-list"-->
    <!--    >-->
    <!--      <MainCollapse-->
    <!--        v-for="(section, index) in rdo_documents"-->
    <!--        :key="index"-->
    <!--        :title="section.title"-->
    <!--        auto-close-->
    <!--        :select="select_rdo_section === index + 1"-->
    <!--        @select="selectRdoSection(index)"-->
    <!--      >-->
    <!--        <DocumentsVideo :data="section" />-->
    <!--      </MainCollapse>-->
    <!--    </div>-->
  </div>
</template>

<style lang="scss">
.documents-section {
  padding-top: $space-xxl;
  padding-bottom: $space-xxl;

  &__title {
    margin-top: $space-m;
    margin-bottom: $space-xxxl;
  }

  &__section-selector {
    max-width: 660px;
    margin-bottom: 40px;
    display: grid;
    align-items: center;
    grid-template-columns: 16px 1fr 16px;
    column-gap: $space-l;

    .main-select {
      &__items {
        max-width: 100% !important;
      }

      &_background-white {
        max-width: 100%;
        width: 100%;
      }
    }
  }

  &__arrow {
    cursor: pointer;
    display: inline-block;
    width: 16px;
    height: 16px;
    background: $dark-fourth;
    mask: url("../../assets/icons/arrow_bold.svg");
    -webkit-mask-size: cover;
    mask-size: cover;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;

    &:first-child {
      transform: rotate(180deg);
    }

    &_disabled {
      cursor: not-allowed;
      background: $light-sixth;

      &:hover,
      &:active {
        background: $light-sixth !important;
      }
    }

    &:hover {
      background: $dark-primary;
    }

    &:active {
      background: $dark-fourth;
    }
  }

  .main-loader {
    max-width: 660px;
  }

  &__documents {
    max-width: 660px;
    background-color: $light-primary;
    padding: $space-xl;
    border-radius: $space-s;

    .main-document__wrapper {
      margin-right: 0 !important;
    }
  }

  &__collapse-list {
    max-width: 660px;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 8px;
  }

  &__collapse-item {
    padding-top: 24px;
    @include body-1();
    color: $dark-primary;
  }
}

@media (max-width: 424px) {
  .documents-section {
    padding-bottom: $space-xl;
  }
}
</style>
